import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button10Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11C8.53757 11 11 8.53757 11 5.5ZM7.33333 5.5C7.33333 4.48749 6.51252 3.66666 5.5 3.66666C4.48748 3.66666 3.66667 4.48749 3.66667 5.5C3.66667 6.51251 4.48748 7.33334 5.5 7.33334C6.51252 7.33334 7.33333 6.51251 7.33333 5.5ZM12 8H21V3H12V8ZM8 21V12H3V21H8Z" />
  </SvgIcon>
);

export default PO28Button10Icon;
